export default {"src":"/_next/static/media/icon-stats.a950c41b.svg","height":882,"width":946};